import {
  Constants,
  useMeeting,
  usePubSub,
  useMediaDevice,
} from "@videosdk.live/react-sdk";
import logger from '../../utils/logger';
import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { createPopper } from "@popperjs/core";
import { useMeetingAppContext } from "../../MeetingAppContextDef";
import useMediaStream from "../../hooks/useMediaStream";
import { sideBarModes } from "../../utils/common";
import SettingsPanel from "./SettingsPanel";
import MobileBottomBar from "./MobileBottomBar";
import MobileSwipeUpPanel from "./MobileSwipeUpPanel";
import CaptionTranslationPanel from "./CaptionTranslationPanel";
import { backgroundImageUrls } from "../../utils/background";
import {
  VirtualBackgroundProcessor,
  VideoSDKNoiseSuppressor,
} from "@videosdk.live/videosdk-media-processor-web";
import {
  createCameraVideoTrack,
  createMicrophoneAudioTrack,
} from "@videosdk.live/react-sdk";
import useIsRecording from "../../hooks/useIsRecording";
import { useSiteContext } from "../../context/SiteContext";
import { emojis, translationLanguages } from "../../utils/list";
import { Smile } from "lucide-react";
import useIsMobile from "../../hooks/useIsMobile";
import useWindowSize from "../../hooks/useWindowSize";
import { useNavigate } from "react-router-dom";
import { useWhiteboard } from "@videosdk.live/react-sdk";
import { useParticipant } from "@videosdk.live/react-sdk";
import MenuItem from "../../components/MenuItem";
import * as meetingServices from "../../services/meetingServices";
import { toast } from "react-toastify";
import { createPortal } from "react-dom";
import BreakoutRoomsModal from "../../components/breakout-rooms/BreakoutRoomsModal";
import BreakoutRoomsParticipantPanel from "../../components/breakout-rooms/BreakoutRoomsParticipantPanel";
import { useBreakoutRooms } from "../../context/BreakoutRoomsContext";

const TopBarWebinar = ({
  setIsMeetingLeft,
  setCustomVideoStream,
  micOn,
  setMicOn,
  webcamOn,
  setWebcamOn,
  customAudioStream,
  setCustomAudioStream,
  customVideoStream,
  startTranscription,
  stopTranscription,
  startTranslation,
  stopTranslation,
  changeTranslationLanguage,
}) => {
  const { startWhiteboard, stopWhiteboard, whiteboardUrl } = useWhiteboard();
  const {
    meetingRole,
    user,
    isAuthenticated,
    meetingSettings,
    setShowElementSection,
    showElementSection,
    translationStatus,
  } = useSiteContext();
  const {
    selectedMic,
    setSelectedMic,
    selectedSpeaker,
    setSelectedSpeaker,
    isMicrophonePermissionAllowed,
    sideBarMode,
    setSideBarMode,
    selectedWebcam,
    setUnreadChat,
    unreadChat,
    recentReactions,
    setRecentReactions,
    selectedLanguage,
    setSelectedLanguage,
    setTranslationEnabled,
    translationEnabled,
    setTranscriptionEnabled,
    transcriptionEnabled,
    virtualBackgroundOn,
    setVirtualBackgroundOn,
    participantApproveFunc,
    approvalSoundEnabled,
    setApprovalSoundEnabled,
    participantWebinarFunc,
  } = useMeetingAppContext();

  logger("log", "unreadChat", unreadChat);
  const isMobile = useIsMobile();
  const windowSize = useWindowSize();
  const isMobileLike =
    (windowSize?.height || 0) > 0 && windowSize.height < 500 ? true : isMobile;
  const isLandscapeOrientation =
    (windowSize?.width || 0) > 0 &&
    (windowSize?.height || 0) > 0 &&
    windowSize.width > windowSize.height;
  const navigate = useNavigate();

  const { getMicrophones, getPlaybackDevices } = useMediaDevice();
  const videoProcessor = new VirtualBackgroundProcessor();
  const noiseProcessorRef = useRef(null);
  const mMeeting = useMeeting();
  const [mics, setMics] = useState([]);
  const [speakers, setSpeakers] = useState([]);
  const localMicOn = mMeeting?.localMicOn;
  const changeMic = mMeeting?.changeMic;
  const [isLiveStreaming, setIsLiveStreaming] = useState(false);

  const { getVideoTrack } = useMediaStream();
  const videoTrackRef = useRef();
  const audioTrackRef = useRef();
  const [videoTrack, setVideoTrack] = useState(null);

  const localWebcamOn = mMeeting?.localWebcamOn;
  const changeWebcam = mMeeting?.changeWebcam;

  const [showMore, setShowMore] = useState(false);
  const [showSetting, setShowSetting] = useState(false);
  const [showVirtualBackgroundModal, setShowVirtualBackgroundModal] =
    useState(false);
  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [webcams, setWebcams] = useState([]);
  const { getCameras } = useMediaDevice();
  const [showReactions, setShowReactions] = useState(false);
  const [showToolsDropdown, setShowToolsDropdown] = useState(false);
  const [showCaptionsDropdown, setShowCaptionsDropdown] = useState(false);
  const [showBreakoutRoomsModal, setShowBreakoutRoomsModal] = useState(false);

  // Debug: Log when modal state changes
  useEffect(() => {
    if (showBreakoutRoomsModal) {
      logger("log", "Breakout Rooms Modal should be visible now. meetingRole:", meetingRole);
    }
  }, [showBreakoutRoomsModal, meetingRole]);
  const [showMicDropdown, setShowMicDropdown] = useState(false);
  const [showSpeakerDropdown, setShowSpeakerDropdown] = useState(false);
  const [showVideoDropdown, setShowVideoDropdown] = useState(false);
  const [showLayoutDropdown, setShowLayoutDropdown] = useState(false);
  const [showMobilePanel, setShowMobilePanel] = useState(false);
  const [showCaptionTranslationPanel, setShowCaptionTranslationPanel] =
    useState(false);
  const [showAudioInputDropdown, setShowAudioInputDropdown] = useState(false);
  const [showVideoSourceDropdown, setShowVideoSourceDropdown] = useState(false);
  const [blurEnabled, setBlurEnabled] = useState(false);
  const [blurStrength, setBlurStrength] = useState(50);
  const [selectedBackground, setSelectedBackground] = useState(null);

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [fontSize, setFontSize] = useState("A+");
  const [captionPosition, setCaptionPosition] = useState("bottom");
  const [selectedLayout, setSelectedLayout] = useState("gallery");
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [hideSelfView, setHideSelfView] = useState(false);
  const [showNonVideoParticipants, setShowNonVideoParticipants] =
    useState(true);
  const [showMeetingName, setShowMeetingName] = useState(true);
  const [compactMode, setCompactMode] = useState(false);
  const [isTogglingMic, setIsTogglingMic] = useState(false);
  const [isTogglingWebcam, setIsTogglingWebcam] = useState(false);


  // Live streaming states
  const [showLiveStreamModal, setShowLiveStreamModal] = useState(false);
  const [liveStreamPlatforms, setLiveStreamPlatforms] = useState({
    facebook: false,
    youtube: false,
    linkedin: false,
  });
  const [streamingCredentials, setStreamingCredentials] = useState({
    facebook: {
      url: meetingSettings && meetingSettings.streamFacebookUrl,
      key: meetingSettings && meetingSettings.streamFacebookKey,
    },
    youtube: {
      url: meetingSettings && meetingSettings.streamYouTubeUrl,
      backupUrl: "",
      key: meetingSettings && meetingSettings.streamYouTubeKey,
    },
    linkedin: {
      url: meetingSettings && meetingSettings.streamLinkedInUrl,
      key: meetingSettings && meetingSettings.streamLinkedInKey,
    },
  });

  const [streamingStartTime, setStreamingStartTime] = useState(null);
  const [streamingElapsedMs, setStreamingElapsedMs] = useState(0);



  const { publish: publishRaiseHand } = usePubSub("RAISE_HAND");
  const { publish: publishReaction } = usePubSub("EMOJI_REACTION");
  const { publish: publishReactionBreakout } = usePubSub("EMOJI_REACTION_BREAKOUT");

  // Get current room for breakout room reactions
  const { currentRoom } = useBreakoutRooms();

  const isRecording = useIsRecording();
  const isRecordingRef = useRef(isRecording);

  useEffect(() => {
    if (
      meetingSettings &&
      ["moderator", "co-host"].includes(meetingRole) &&
      meetingSettings.autoRecordWebinar
    ) {
      handleConfirmStartRecording();
    }
  }, [meetingSettings, meetingRole]);

  useEffect(() => {
    isRecordingRef.current = isRecording;
  }, [isRecording]);

  // Live streaming timer
  useEffect(() => {
    let intervalId;
    if (isLiveStreaming && streamingStartTime) {
      intervalId = setInterval(() => {
        setStreamingElapsedMs(Date.now() - streamingStartTime);
      }, 1000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isLiveStreaming, streamingStartTime]);

  // Recording confirmation/consent modals
  const [showStartRecordingModal, setShowStartRecordingModal] = useState(false);
  const [showRecordingConsentModal, setShowRecordingConsentModal] =
    useState(false);

  // Broadcast and listen for recording notices
  const { publish: publishRecordingNotice } = usePubSub("RECORDING_NOTICE", {
    onMessageReceived: ({ message, senderId }) => {
      const messageData = typeof message === "string" ? JSON.parse(message) : message;
      if (!messageData) return;
      logger("log", "publishRecordingNotice", message, senderId);
      if (
        messageData?.type === "started" &&
        senderId !== mMeeting?.localParticipant?.id
      ) {
        setRecordingStartAt(message.at || Date.now());
        setShowRecordingConsentModal(true);
      } else if (message?.type == "auto-started") {
        setRecordingStartAt(message.at || Date.now());
        setRecordingElapsedMs(0);
        setIsRecordingPaused(false);
        setPausedAtMs(0);
      }
    },
  });

  // Recording pill state and helpers
  const [recordingStartAt, setRecordingStartAt] = useState(null);
  const [recordingElapsedMs, setRecordingElapsedMs] = useState(0);
  const [isRecordingPaused, setIsRecordingPaused] = useState(false);
  const [pausedAtMs, setPausedAtMs] = useState(0);

  // Timer for recording pill
  useEffect(() => {
    let intervalId;
    if (
      mMeeting.recordingState === Constants.recordingEvents.RECORDING_STARTED &&
      recordingStartAt &&
      !isRecordingPaused
    ) {
      intervalId = setInterval(() => {
        setRecordingElapsedMs(Date.now() - recordingStartAt);
      }, 1000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [mMeeting.recordingState, recordingStartAt, isRecordingPaused]);

  const handlePauseRecording = () => {
    if (isRecordingPaused) {
      const pausedDuration = Date.now() - (recordingStartAt + pausedAtMs);
      setRecordingStartAt(Date.now() - pausedAtMs);
      setIsRecordingPaused(false);
      setPausedAtMs(0);
    } else {
      setIsRecordingPaused(true);
      setPausedAtMs(recordingElapsedMs);
    }
  };

  const handleStopRecording = () => {
    setIsRecordingPaused(false);
    setPausedAtMs(0);
    mMeeting.stopRecording();
    stopTranscription && stopTranscription();
  };

  // Live streaming functions
  const handleStartLiveStream = async (platforms) => {
    try {
      const outputs = [];

      // Add selected platforms to outputs
      if (platforms.facebook) {
        outputs.push({
          url: streamingCredentials.facebook.url,
          streamKey: streamingCredentials.facebook.key,
        });
      }

      if (platforms.youtube) {
        outputs.push({
          url: streamingCredentials.youtube.url,
          streamKey: streamingCredentials.youtube.key,
        });
      }

      if (platforms.linkedin) {
        outputs.push({
          url: streamingCredentials.linkedin.url,
          streamKey: streamingCredentials.linkedin.key,
        });
      }

      if (outputs.length === 0) {
        alert("Please select at least one platform to stream to.");
        return;
      }

      // Start live streaming
      const liveReponse = await mMeeting.startLivestream(outputs, {
        // Layout Configuration
        layout: {
          type: "GRID", // "SPOTLIGHT" | "SIDEBAR",  Default : "GRID"
          priority: "SPEAKER", // "PIN", Default : "SPEAKER"
          gridSize: 4, // MAX : 4
        },

        // Theme of livestream layout
        theme: "DARK", //  "LIGHT" | "DEFAULT"
      });

      logger("log", "liveReponse", liveReponse);

      setIsLiveStreaming(true);
      setLiveStreamPlatforms(platforms);
      setStreamingStartTime(Date.now());
      setShowLiveStreamModal(false);

      logger("log", "Live streaming started to:", platforms);
    } catch (error) {
      logger("error", "Error starting live stream:", error);
      alert("Failed to start live stream. Please try again.");
    }
  };

  const handleStopLiveStream = async () => {
    try {
      await mMeeting.stopLivestream();

      setIsLiveStreaming(false);
      setLiveStreamPlatforms({
        facebook: false,
        youtube: false,
        linkedin: false,
      });
      setStreamingStartTime(null);
      setStreamingElapsedMs(0);

      logger("log", "Live streaming stopped");
    } catch (error) {
      logger("error", "Error stopping live stream:", error);
    }
  };

  const formatDuration = (ms) => {
    const total = Math.max(0, Math.floor(ms / 1000));
    const mm = String(Math.floor(total / 60)).padStart(2, "0");
    const ss = String(total % 60).padStart(2, "0");
    return `${mm}:${ss}`;
  };

  const { isRequestProcessing } = useMemo(
    () => ({
      isRequestProcessing:
        mMeeting.recordingState ===
        Constants.recordingEvents.RECORDING_STARTING ||
        mMeeting.recordingState ===
        Constants.recordingEvents.RECORDING_STOPPING,
    }),
    [mMeeting.recordingState]
  );

  const handleRecordingClick = () => {
    const isRecording = isRecordingRef.current;
    logger("log", "isRecording", mMeeting.recordingState);
    if (isRecording) {
      setIsRecordingPaused(false);
      setPausedAtMs(0);
      setRecordingStartAt(null);
      mMeeting.stopRecording();
      stopTranscription && stopTranscription();
    } else {
      setShowStartRecordingModal(true);
    }
  };

  const handleConfirmStartRecording = () => {
    const at = Date.now();
    setRecordingStartAt(at);
    setRecordingElapsedMs(0);
    setIsRecordingPaused(false);
    setPausedAtMs(0);
    if (
      mMeeting.recordingState == Constants.recordingEvents.RECORDING_STARTED ||
      mMeeting.recordingState == Constants.recordingEvents.RECORDING_STARTING
    ) {
      return;
    }
    mMeeting.startRecording();
    if (mMeeting && mMeeting.transcriptionState == Constants.transcriptionEvents.TRANSCRIPTION_STOPPED) {
      startTranscription();
    }
    setTranscriptionEnabled((prevEnabled) => {
      const nextEnabled = !prevEnabled;
      return nextEnabled;
    });
    try {
      publishRecordingNotice({ type: "started", at });
    } catch (_) { }
    setShowStartRecordingModal(false);
  };

  const { mode } = useParticipant(mMeeting?.localParticipant?.id);

  useMediaDevice({
    onDeviceChanged,
  });

  useEffect(() => {
    getWebcams();
    getMics();
  }, []);

  function onDeviceChanged(devices) {
    getMics();
    const newSpeakerList = devices.devices.filter(
      (device) => device.kind === "audiooutput"
    );

    // Only auto-select speaker if no speaker is currently selected
    // This prevents automatic setSinkId calls without user gesture
    if (newSpeakerList.length > 0 && !selectedSpeaker?.id) {
      setSelectedSpeaker({
        id: newSpeakerList[0].deviceId,
        label: newSpeakerList[0].label,
      });
    }
  }

  const getMics = async () => {
    const mics = await getMicrophones();
    const speakers = await getPlaybackDevices();

    mics && mics?.length && setMics(mics);
    speakers && speakers?.length && setSpeakers(speakers);
  };

  const getWebcams = async () => {
    let webcams = await getCameras();
    webcams && webcams?.length && setWebcams(webcams);
  };

  const [tooltipShow, setTooltipShow] = useState(false);
  const btnRef = useRef();
  const tooltipRef = useRef();

  const openTooltip = () => {
    createPopper(btnRef.current, tooltipRef.current, {
      placement: "top",
    });
    setTooltipShow(true);
  };
  const closeTooltip = () => {
    setTooltipShow(false);
  };

  const handleToggleFullscreen = async () => {
    try {
      if (!document.fullscreenElement) {
        await document.documentElement.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
    } catch (_) { }
    setShowMore(false);
  };

  const handleCopyRoomLink = () => {
    try {
      const href = window.location?.href || "";
      navigator.clipboard?.writeText(href).catch(() => { });
    } catch (_) { }
    setShowMore(false);
  };

  const handleToggleMic = async () => {
    if (isTogglingMic) return; // Prevent multiple clicks

    // Webinar mode check
    if (
      meetingSettings?.roomType === "Webinar" &&
      mode != Constants.modes.SEND_AND_RECV
    ) {
      return;
    }

    setIsTogglingMic(true);
    try {
      if (localMicOn) {
        // Muting - stop noise processor and mute mic
        if (noiseProcessorRef.current) {
          try {
            if (noiseProcessorRef.current.stopProcessing) {
              await noiseProcessorRef.current.stopProcessing();
            }
          } catch (error) {
            logger("log", "Error stopping noise processor:", error);
          }
          noiseProcessorRef.current = null;
        }
        mMeeting.muteMic();
      } else {
        // Check global guest can unmute setting
        if (
          meetingRole !== "moderator" &&
          meetingRole !== "co-host" &&
          meetingRole !== "speaker" &&
          meetingSettings?.muteParticipants &&
          !meetingSettings?.guestCanUnmute
        ) {
          toast.error(
            "You are not allowed to unmute your mic controlled by host"
          );
          return;
        }

        // Unmuting - create noise suppression and unmute mic
        if (isMobile) {
          mMeeting.unmuteMic();
          // Create a new noise processor instance each time to avoid "processing has already started" error
          if (noiseProcessorRef.current) {
            try {
              if (noiseProcessorRef.current.stopProcessing) {
                await noiseProcessorRef.current.stopProcessing();
              }
            } catch (error) {
              logger("log", "Error stopping noise processor:", error);
            }
          }
          noiseProcessorRef.current = new VideoSDKNoiseSuppressor();

          const stream = await createMicrophoneAudioTrack({});
          const processedStream =
            await noiseProcessorRef.current.getNoiseSuppressedAudioStream(stream);

          // Set the processed stream directly
          setCustomAudioStream(processedStream);
          changeMic(processedStream);
        } else {
          // Desktop - just unmute without noise suppression
          mMeeting.unmuteMic();
        }
      }
    } finally {
      setIsTogglingMic(false);
    }
  };

  const handleToggleWebcam = async () => {
    if (isTogglingWebcam) return; // Prevent multiple clicks

    setIsTogglingWebcam(true);
    try {
      if (localWebcamOn) {
        mMeeting.disableWebcam();
      } else {
        mMeeting.enableWebcam();
      }
    } finally {
      setIsTogglingWebcam(false);
    }
  };

  const handleStartVirtualBackground = async (background) => {
    // Initialize processor if not ready
    logger("log", "videoProcessor", videoProcessor);

    if (!videoProcessor.ready) {
      await videoProcessor.init();
    }

    if (!background) {
      videoProcessor.stop();

      // Pass webcam MediaStream in VideoSDK `changeWebcam` method
      const stream = await createCameraVideoTrack({});
      changeWebcam(stream);
      setVirtualBackgroundOn(false);
      setSelectedBackground(null);
      return;
    }

    // Configuration for starting processor
    const config = blurEnabled
      ? {
        type: "blur",
        blurStrength: blurStrength,
      }
      : {
        type: "image",
        imageUrl: background,
      };

    // Getting stream from webcam
    const stream = await createCameraVideoTrack({});
    const processedStream = await videoProcessor.start(stream, config);
    logger("log", "webcamOn", webcamOn);
    if (webcamOn) {
      changeWebcam(processedStream);
      setVirtualBackgroundOn(true);
      setSelectedBackground(background);
    }
  };

  const handleLeaveModal = () => {
    logger("log", mMeeting, "mMeeting");
    setShowLeaveModal(true);
    localStorage.setItem("rejoinId", window.location.href);
  };

  const handleLeaveConfirm = () => {
    // Disable webcam and mic to turn off browser tab indicators
    mMeeting.localParticipant.disableWebcam();
    mMeeting.localParticipant.disableMic();

    // Clean up noise processor
    if (noiseProcessorRef.current) {
      try {
        if (noiseProcessorRef.current.stopProcessing) {
          noiseProcessorRef.current.stopProcessing();
        }
      } catch (error) {
        logger("log", "Error stopping noise processor on leave:", error);
      }
      noiseProcessorRef.current = null;
    }

    // Explicitly stop all active media tracks to ensure browser tab indicators are off
    try {
      // Stop tracks from custom video stream if it exists
      if (customVideoStream && customVideoStream.getTracks) {
        customVideoStream.getTracks().forEach((track) => {
          if (track.readyState !== "ended") {
            track.stop();
          }
        });
      }

      // Stop tracks from custom audio stream if it exists
      if (customAudioStream && customAudioStream.getTracks) {
        customAudioStream.getTracks().forEach((track) => {
          if (track.readyState !== "ended") {
            track.stop();
          }
        });
      }

      // Stop all tracks from all video elements on the page
      const videoElements = document.querySelectorAll("video");
      videoElements.forEach((videoElement) => {
        if (videoElement.srcObject instanceof MediaStream) {
          videoElement.srcObject.getTracks().forEach((track) => {
            if (track.readyState !== "ended") {
              track.stop();
            }
          });
        }
      });

      // Stop all tracks from all audio elements on the page
      const audioElements = document.querySelectorAll("audio");
      audioElements.forEach((audioElement) => {
        if (audioElement.srcObject instanceof MediaStream) {
          audioElement.srcObject.getTracks().forEach((track) => {
            if (track.readyState !== "ended") {
              track.stop();
            }
          });
        }
      });
    } catch (error) {
      logger("error", "Error stopping media tracks:", error);
    }

    if (meetingRole === "moderator") {
      try {
        meetingServices.saveMeetingSession(meetingSettings?.roomId);
      } catch (error) {
        logger("error", "Error saving meeting session:", error);
      }
    }
    // Small delay to ensure tracks are stopped before leaving
    setTimeout(() => {
      mMeeting.leave();
      if (meetingSettings?.exitUrl && meetingSettings.exitUrl != "false") {
        window.location.href = meetingSettings.exitUrl;
      } else {
        setIsMeetingLeft(true);
        setShowLeaveModal(false);
      }
    }, 100);
  };

  const handleEndForAll = () => {
    // Disable webcam and mic to turn off browser tab indicators
    mMeeting.localParticipant.disableWebcam();
    mMeeting.localParticipant.disableMic();

    // Clean up noise processor
    if (noiseProcessorRef.current) {
      try {
        if (noiseProcessorRef.current.stopProcessing) {
          noiseProcessorRef.current.stopProcessing();
        }
      } catch (error) {
        logger("log", "Error stopping noise processor on end:", error);
      }
      noiseProcessorRef.current = null;
    }

    // Explicitly stop all active media tracks to ensure browser tab indicators are off
    try {
      // Stop tracks from custom video stream if it exists
      if (customVideoStream && customVideoStream.getTracks) {
        customVideoStream.getTracks().forEach((track) => {
          if (track.readyState !== "ended") {
            track.stop();
          }
        });
      }

      // Stop tracks from custom audio stream if it exists
      if (customAudioStream && customAudioStream.getTracks) {
        customAudioStream.getTracks().forEach((track) => {
          if (track.readyState !== "ended") {
            track.stop();
          }
        });
      }

      // Stop all tracks from all video elements on the page
      const videoElements = document.querySelectorAll("video");
      videoElements.forEach((videoElement) => {
        if (videoElement.srcObject instanceof MediaStream) {
          videoElement.srcObject.getTracks().forEach((track) => {
            if (track.readyState !== "ended") {
              track.stop();
            }
          });
        }
      });

      // Stop all tracks from all audio elements on the page
      const audioElements = document.querySelectorAll("audio");
      audioElements.forEach((audioElement) => {
        if (audioElement.srcObject instanceof MediaStream) {
          audioElement.srcObject.getTracks().forEach((track) => {
            if (track.readyState !== "ended") {
              track.stop();
            }
          });
        }
      });
    } catch (error) {
      logger("error", "Error stopping media tracks:", error);
    }

    if (meetingRole === "moderator") {
      try {
        meetingServices.saveMeetingSession(meetingSettings?.roomId);
      } catch (error) {
        logger("error", "Error saving meeting session:", error);
      }
    }

    // Small delay to ensure tracks are stopped before ending
    setTimeout(() => {
      mMeeting.end();
      if (meetingSettings?.exitUrl && meetingSettings.exitUrl != "false") {
        window.location.href = meetingSettings.exitUrl;
      } else {
        setIsMeetingLeft(true);
        setShowLeaveModal(false);
      }
    }, 100);
  };

  const handleLeaveCancel = () => {
    setShowLeaveModal(false);
  };

  const handleEmojiClick = ({ char, alt }) => {
    // Publish to breakout room topic if in a breakout room, otherwise main meeting topic
    if (currentRoom) {
      publishReactionBreakout(JSON.stringify({ char, alt }));
    } else {
      publishReaction(JSON.stringify({ char, alt }));
    }
    setShowReactions(false);
  };

  // Touch event handlers for swipe detection
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientY);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientY);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isUpSwipe = distance > minSwipeDistance;
    const isDownSwipe = distance < -minSwipeDistance;

    if (isUpSwipe) {
      setShowMobilePanel(true);
    } else if (isDownSwipe) {
      setShowMobilePanel(false);
    }
  };

  useEffect(() => {
    logger("log", "user ", user);
  }, [user]);

  // Cleanup noise processor on unmount
  useEffect(() => {
    return () => {
      if (noiseProcessorRef.current) {
        try {
          if (noiseProcessorRef.current.stopProcessing) {
            noiseProcessorRef.current.stopProcessing();
          }
        } catch (error) {
          logger("log", "Error stopping noise processor on unmount:", error);
        }
        noiseProcessorRef.current = null;
      }
    };
  }, []);

  // Handle click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const triggerButton = event.target.closest(
        'button[aria-label="Mic"], button[aria-label="Speaker"], button[aria-label="Video"], button[aria-label="Layout"], button[aria-label="Tools"], button[aria-label="Captions"], button[aria-label="Settings"], button[aria-label="Reactions"]'
      );
      if (triggerButton) return;

      if (
        showToolsDropdown ||
        showCaptionsDropdown ||
        showMicDropdown ||
        showSpeakerDropdown ||
        showVideoDropdown ||
        showLayoutDropdown ||
        showMore ||
        showReactions ||
        showCaptionTranslationPanel
      ) {
        const toolsDropdown = document.querySelector("[data-tools-dropdown]");
        const captionsDropdown = document.querySelector(
          "[data-captions-dropdown]"
        );
        const micDropdown = document.querySelector("[data-mic-dropdown]");
        const videoDropdown = document.querySelector("[data-video-dropdown]");
        const layoutDropdown = document.querySelector("[data-layout-dropdown]");
        const moreDropdown = document.querySelector("[data-more-dropdown]");
        const reactionsDropdown = document.querySelector(
          "[data-reactions-dropdown]"
        );
        const captionTranslationPanel = document.querySelector(
          "[data-caption-translation-panel]"
        );

        // Close  dropdowns on outside click
        if (
          showToolsDropdown &&
          toolsDropdown &&
          !toolsDropdown.contains(event.target)
        ) {
          setShowToolsDropdown(false);
        }

        if (
          showCaptionsDropdown &&
          captionsDropdown &&
          !captionsDropdown.contains(event.target)
        ) {
          setShowCaptionsDropdown(false);
        }

        if (
          showMicDropdown &&
          micDropdown &&
          !micDropdown.contains(event.target)
        ) {
          setShowMicDropdown(false);
        }

        if (
          showSpeakerDropdown &&
          micDropdown &&
          !micDropdown.contains(event.target)
        ) {
          setShowSpeakerDropdown(false);
        }

        if (
          showVideoDropdown &&
          videoDropdown &&
          !videoDropdown.contains(event.target)
        ) {
          setShowVideoDropdown(false);
        }

        if (
          showLayoutDropdown &&
          layoutDropdown &&
          !layoutDropdown.contains(event.target)
        ) {
          setShowLayoutDropdown(false);
        }

        if (showMore && moreDropdown && !moreDropdown.contains(event.target)) {
          setShowMore(false);
        }

        if (
          showReactions &&
          reactionsDropdown &&
          !reactionsDropdown.contains(event.target)
        ) {
          setShowReactions(false);
        }

        if (
          showCaptionTranslationPanel &&
          captionTranslationPanel &&
          !captionTranslationPanel.contains(event.target)
        ) {
          setShowCaptionTranslationPanel(false);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [
    showToolsDropdown,
    showCaptionsDropdown,
    showMicDropdown,
    showSpeakerDropdown,
    showVideoDropdown,
    showLayoutDropdown,
    showMore,
    showReactions,
    showCaptionTranslationPanel,
  ]);

  // Settings rows for SettingsPanel
  const TranscriptionToggleRow = ({ variant = "dark", className = "" }) => {
    const isLight = variant === "light";
    const labelColor = isLight ? "text-slate-800" : "text-white";
    const switchBackground = transcriptionEnabled
      ? "bg-[#7c3aed] shadow-[0_0_0_4px_rgba(124,58,237,0.25)]"
      : isLight
        ? "bg-slate-300"
        : "bg-gray-600";
    const thumbTransform = transcriptionEnabled
      ? "translate-x-[1.4rem]"
      : "translate-x-1";
    const thumbStyles = transcriptionEnabled
      ? "bg-white shadow-[0_6px_14px_rgba(124,58,237,0.35)]"
      : "bg-white shadow-sm";

    return (
      <div
        className={`w-full px-3 py-2 flex items-center justify-between gap-4 ${className}`}
      >
        <span className={`text-sm font-medium leading-5 ${labelColor}`}>
          Show Transcription
        </span>
        <button
          onMouseDown={(event) => event.stopPropagation()}
          onClick={(event) => {
            event.stopPropagation();
            setTranscriptionEnabled((prev) => {
              const nextEnabled = !prev;

              if (prev) {
                if (mMeeting && mMeeting.transcriptionState == Constants.transcriptionEvents.TRANSCRIPTION_STARTED) {
                  stopTranscription();
                }
              } else {
                if (mMeeting && mMeeting.transcriptionState == Constants.transcriptionEvents.TRANSCRIPTION_STOPPED) {
                  startTranscription();
                }
              }

              return nextEnabled;
            });
          }}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#7700ff]/40 ${switchBackground}`}
          role="switch"
          aria-checked={transcriptionEnabled}
          aria-label={
            transcriptionEnabled
              ? "Disable live transcription"
              : "Enable live transcription"
          }
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full transition-all duration-200 ease-out ${thumbTransform} ${thumbStyles}`}
          />
        </button>
      </div>
    );
  };

  const ApprovalSoundToggleRow = ({ variant = "dark", className = "" }) => {
    const isLight = variant === "light";
    const labelColor = isLight ? "text-slate-800" : "text-white";
    const switchBackground = approvalSoundEnabled
      ? "bg-[#7c3aed] shadow-[0_0_0_4px_rgba(124,58,237,0.25)]"
      : isLight
        ? "bg-slate-300"
        : "bg-gray-600";
    const thumbTransform = approvalSoundEnabled
      ? "translate-x-[1.4rem]"
      : "translate-x-1";
    const thumbStyles = approvalSoundEnabled
      ? "bg-white shadow-[0_6px_14px_rgba(124,58,237,0.35)]"
      : "bg-white shadow-sm";

    return (
      <div
        className={`w-full px-3 py-2 flex items-center justify-between gap-4 ${className}`}
      >
        <span className={`text-sm font-medium leading-5 ${labelColor}`}>
          Enable Approval Sound
        </span>
        <button
          onMouseDown={(event) => event.stopPropagation()}
          onClick={(event) => {
            event.stopPropagation();
            setApprovalSoundEnabled((prev) => !prev);
          }}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#7700ff]/40 ${switchBackground}`}
          role="switch"
          aria-checked={approvalSoundEnabled}
          aria-label={
            approvalSoundEnabled
              ? "Disable Approval Sound"
              : "Enable Approval Sound"
          }
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full transition-all duration-200 ease-out ${thumbTransform} ${thumbStyles}`}
          />
        </button>
      </div>
    );
  };

  // Placeholders (not used in webinar flow)
  const WaitingRoomToggleRow = () => null;
  const GuestCanUnmuteToggleRow = () => null;

  return (
    <div
      className={`select-none sticky top-0 w-full z-20 border-b border-[#39364A] px-1 sm:px-2 md:px-3 lg:px-4 xl:px-6 bg-black text-white flex items-center relative ${compactMode
        ? "h-[40.97px]  transition-all duration-300 ease-in-out"
        : "h-16 md:h-[60px] transition-all duration-300 ease-in-out"
        }`}
    >
      {/* Notch with curved border */}
      {!isMobileLike && (
        <div className="absolute left-1/2 -translate-x-1/2 -bottom-[7px] w-[60px] h-[7px] z-30">
          <div
            className="relative w-full h-full bg-black rounded-b-full border-x border-b border-[#39364A] shadow-sm flex items-center justify-center cursor-pointer"
            onClick={() => setCompactMode(!compactMode)}
          >
            <img
              src="/icons/chevronDown.svg"
              alt="Toggle compact mode"
              className={`mb-1 transition-transform duration-300 ease-in-out ${!compactMode ? "rotate-180" : ""
                }`}
            />
          </div>
        </div>
      )}

      {isRecording && (
        <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 flex items-center gap-2 bg-transparent border border-[#39364A] text-white px-3 py-1.5 rounded-lg shadow-lg">
          <span className="inline-block w-2 h-2 bg-red-500 rounded-xl animate-pulse" />
          <span className="text-[10px] tracking-widest text-gray-300">
            RECORDING
          </span>
          <span className="text-[10px] font-mono text-white">
            {formatDuration(
              isRecordingPaused ? pausedAtMs : recordingElapsedMs
            )}
          </span>
          {meetingRole === "moderator" && (
            <>
              <button
                onClick={handlePauseRecording}
                className="ml-2 flex items-center justify-center w-4 h-4 text-gray-300 hover:text-white transition-colors"
                title={isRecordingPaused ? "Resume" : "Pause"}
                aria-label={
                  isRecordingPaused ? "Resume recording" : "Pause recording"
                }
              >
                {isRecordingPaused ? (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
                  </svg>
                )}
              </button>
              <button
                onClick={handleStopRecording}
                className="flex items-center justify-center w-3 h-3 text-gray-300 hover:text-white transition-colors bg-[#7700FF]"
                title="Stop Recording"
                aria-label="Stop recording"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="#7700FF">
                  <path d="M6 6h12v12H6z" />
                </svg>
              </button>
            </>
          )}
        </div>
      )}
      {/* Start Recording Confirmation */}
      {showStartRecordingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowStartRecordingModal(false)}
          />
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-lg mx-4 text-white">
            <h3 className="text-xl font-bold mb-4 uppercase text-center">
              Start recording this meeting?
            </h3>
            <p className="text-base text-gray-300 mb-6 text-center">
              Participants will see a notice that the meeting is being recorded.
            </p>
            <div className="flex gap-3 mt-10 justify-end">
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-transparent border border-white text-white hover:bg-white/10"
                onClick={() => setShowStartRecordingModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-[#7700ff] text-white hover:bg-white/10"
                onClick={handleConfirmStartRecording}
              >
                Start Recording
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Recording consent notice for participants */}
      {showRecordingConsentModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowRecordingConsentModal(false)}
          />
          <div className="relative bg-[#060621] border border-gray-700 rounded-2xl p-6 w-full max-w-xl mx-4 text-white">
            <h3 className="text-xl font-bold uppercase text-center mb-2">
              This session is being recorded.
            </h3>
            <p className="text-base text-gray-300 mb-6 mt-2 text-center">
              If you stay, you're giving consent to record audio and video.
              <br />
              Don't want to be recorded? You can leave anytime.
            </p>
            <div className="flex gap-3 mt-10 flex-col sm:flex-row sm:justify-end">
              <button
                className="px-4 py-2 w-1/2 rounded-lg bg-transparent border border-white text-white hover:bg-white/10"
                onClick={() => {
                  mMeeting.leave();
                }}
              >
                Leave Meeting
              </button>
              <button
                className="px-4 py-2 w-1/2 rounded-lg bg-[#7700FF]  text-white hover:bg-white/10"
                onClick={() => setShowRecordingConsentModal(false)}
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Live Streaming pill with timer (centered, below recording if both active) */}
      {isLiveStreaming && (
        <div
          className={`absolute left-1/2 -translate-x-1/2 ${isRecording ? "top-[70%]" : "top-1/2"
            } -translate-y-1/2 flex items-center gap-2 bg-[#1a1a2e] border border-[#39364A] text-white px-3 py-1.5 rounded-full shadow-lg`}
        >
          <span className="inline-block w-2 h-2 bg-red-500 rounded-full animate-pulse" />
          <span className="text-[10px] tracking-widest text-gray-300">
            LIVE
          </span>
          <div className="flex items-center gap-1">
            {liveStreamPlatforms.facebook && (
              <span className="text-[8px] bg-blue-600 px-1 py-0.5 rounded">
                FB
              </span>
            )}
            {liveStreamPlatforms.youtube && (
              <span className="text-[8px] bg-red-600 px-1 py-0.5 rounded">
                YT
              </span>
            )}
            {liveStreamPlatforms.linkedin && (
              <span className="text-[8px] bg-blue-700 px-1 py-0.5 rounded">
                LI
              </span>
            )}
          </div>
          <span className="text-[10px] font-mono text-white">
            {formatDuration(streamingElapsedMs)}
          </span>
          {meetingRole === "moderator" && (
            <button
              onClick={handleStopLiveStream}
              className="ml-2 flex items-center justify-center w-4 h-4 text-gray-300 hover:text-white transition-colors"
              title="Stop Live Stream"
              aria-label="Stop live stream"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M6 6h12v12H6z" />
              </svg>
            </button>
          )}
        </div>
      )}

      {/* Left Section */}
      <div className="flex items-center justify-center w-3/7 h-full">
        <img
          alt="R-Link"
          className={`hidden lg:block  w-auto mr-8 xl:mr-10 2xl:mr-12 ${compactMode ? "h-8" : "h-10"
            } transition-all duration-300 ease-in-out`}
          src={`${compactMode ? "/icons/logoCompact.svg" : "/icons/logoFull.svg"
            }`}
        />
        {/* Mobile Logo */}
        <img
          alt="R-Link"
          className="lg:hidden h-6 sm:h-7 md:h-8 w-auto ml-2 sm:mr-8"
          src="/r-link-fav.svg"
        />
        <div
          className={`${isMobileLike ? "hidden" : "flex"
            } items-center justify-center transition-all duration-300 ease-in-out h-full ${compactMode
              ? "gap-2 lg:gap-2.5 xl:gap-3 2xl:gap-4"
              : "gap-1.5 lg:gap-2 xl:gap-2.5 2xl:gap-3"
            }`}
        >
          <div className="relative h-full">
            <button
              onClick={handleToggleMic}
              disabled={
                meetingSettings?.roomType === "Webinar" &&
                mode == Constants.modes.RECV_ONLY
              }
              className="h-full flex items-center justify-center px-2 text-slate-300 hover:text-white disabled:opacity-50 disabled:cursor-not-allowed"
              title={localMicOn ? "Mute" : "Unmute"}
              aria-label={localMicOn ? "Mute" : "Unmute"}
            >
              <div className="h-full flex items-center gap-1.5 transition-all duration-300 ease-in-out min-w-fit relative">
                {/* Icon and Label Container */}
                <div className="flex flex-col items-center justify-center h-full ">
                  {/* Icon */}
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    <img
                      src={
                        localMicOn ? "/icons/micOn.svg" : "/icons/micOff.svg"
                      }
                      alt={localMicOn ? "Mute" : "Unmute"}
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>

                  {/* Label */}
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Mic
                    </span>
                  )}
                </div>

                <div className="flex items-center justify-center opacity-100 transition-all duration-300 ease-in-out">
                  <img
                    src="/icons/chevronDown.svg"
                    alt="dropdown"
                    className={`cursor-pointer transition-transform duration-200 ${showMicDropdown ? "rotate-180" : ""
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (
                        meetingSettings?.roomType === "Webinar" &&
                        mode != Constants.modes.SEND_AND_RECV
                      ) {
                        return;
                      }
                      setShowMicDropdown(!showMicDropdown);
                      setShowVideoDropdown(false);
                      setShowSpeakerDropdown(false);
                    }}
                    title="Mic Settings"
                    draggable={false}
                  />
                </div>
              </div>
            </button>
            {/* Mic Device Dropdown */}
            {showMicDropdown && (
              <div
                data-mic-dropdown
                className={`absolute top-full left-0 ${compactMode ? "-mt-4" : "mt-2"
                  } w-64 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 transition-all duration-300 ease-in-out`}
              >
                {/* Audio Input Section */}
                <div className="px-4 py-2">
                  <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                    AUDIO INPUT
                  </div>
                  <div className="relative">
                    <div
                      className="flex items-center justify-between w-full px-3 py-3 bg-[#1a1a2e] border border-white/30 rounded-lg text-white text-sm"
                      onClick={() => {
                        setShowAudioInputDropdown(!showAudioInputDropdown);
                      }}
                    >
                      <div className="flex items-center gap-3 min-w-0 flex-1">
                        <img
                          src="/icons/micOn.svg"
                          alt="Microphone"
                          className="flex-shrink-0"
                        />
                        <span className="font-medium truncate min-w-0">
                          {selectedMic?.label || "Select microphone"}
                        </span>
                      </div>

                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        className="flex-shrink-0 ml-2"
                      >
                        <path
                          d="M3.5 5.5L8 10l4.5-4.5"
                          stroke="currentColor"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"
                        />
                      </svg>
                    </div>

                    {/* Device List */}
                    {showAudioInputDropdown && (
                      <div className="absolute top-full left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-[#060621] border border-gray-600 rounded-lg shadow-xl z-10">
                        {mics.map((device) => (
                          <button
                            key={device.deviceId}
                            className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-3 min-w-0"
                            onClick={() => {
                              changeMic(device.deviceId);
                              setShowMicDropdown(false);
                            }}
                          >
                            <img
                              src="/icons/micOn.png"
                              alt="Microphone"
                              className="w-4 h-4 flex-shrink-0"
                            />
                            <span className="truncate min-w-0">
                              {device.label ||
                                `Microphone ${device.deviceId.slice(0, 8)}...`}
                            </span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Audio Output Section */}
                <div className="px-4 py-2">
                  <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                    AUDIO OUTPUT
                  </div>
                  <div className="relative">
                    <button
                      onClick={() =>
                        setShowSpeakerDropdown(!showSpeakerDropdown)
                      }
                      className="flex items-center justify-between w-full px-3 py-3 bg-[#1a1a2e] border border-white/30 rounded-lg text-white text-sm hover:bg-[#1a1a2e]/80 transition-colors min-w-0"
                    >
                      <div className="flex items-center gap-3 min-w-0 flex-1">
                        <svg
                          className="w-5 h-5 text-white flex-shrink-0"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                        </svg>
                        <span className="font-medium truncate min-w-0">
                          {selectedSpeaker?.label || "Select speaker"}
                        </span>
                      </div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        className={`flex-shrink-0 ml-2 transition-transform duration-200 ${showSpeakerDropdown ? "rotate-180" : ""
                          }`}
                      >
                        <path
                          d="M3.5 5.5L8 10l4.5-4.5"
                          stroke="currentColor"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"
                        />
                      </svg>
                    </button>

                    {/* Speaker List */}
                    {showSpeakerDropdown && (
                      <div className="absolute top-full left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-[#060621] border border-gray-600 rounded-lg shadow-xl z-10">
                        {speakers.map((device) => (
                          <button
                            key={device.deviceId}
                            className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-3 min-w-0"
                            onClick={() => {
                              setSelectedSpeaker({
                                id: device.deviceId,
                                label: device.label,
                              });
                              setShowSpeakerDropdown(false);
                            }}
                          >
                            <svg
                              className="w-4 h-4 text-white flex-shrink-0"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                            </svg>
                            <span className="truncate min-w-0">
                              {device.label ||
                                `Speaker ${device.deviceId.slice(0, 8)}...`}
                            </span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Refresh Devices Button */}
                <div className="px-4 py-2">
                  <button
                    onClick={() => {
                      getMics();
                      setShowMicDropdown(false);
                    }}
                    className="flex items-center gap-2 w-full px-4 py-3 bg-[#3A285F] text-white text-sm rounded-lg hover:bg-[#3A285F]/80 transition-colors"
                  >
                    <img
                      src="/icons/refresh.png"
                      alt="Refresh Devices"
                      className=""
                    />
                    <span className="font-medium">REFRESH DEVICES</span>
                  </button>
                </div>
              </div>
            )}
          </div>
          <div className="relative">
            <button
              onClick={handleToggleWebcam}
              disabled={
                isTogglingWebcam ||
                (meetingSettings?.roomType === "Webinar" &&
                  mode == Constants.modes.RECV_ONLY)
              }
              className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              title={localWebcamOn ? "Camera Off" : "Camera On"}
              aria-label={localWebcamOn ? "Camera Off" : "Camera On"}
            >
              <div className="h-full flex items-center gap-1.5 transition-all duration-300 ease-in-out min-w-fit relative">
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    <img
                      src={
                        localWebcamOn
                          ? "/icons/videoCamera.svg"
                          : "/icons/videoOff.svg"
                      }
                      alt={localWebcamOn ? "Camera Off" : "Camera On"}
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Video
                    </span>
                  )}
                </div>
                <div className="flex items-center justify-center opacity-100 transition-all duration-300 ease-in-out">
                  <img
                    src="/icons/chevronDown.svg"
                    alt="dropdown"
                    className={`cursor-pointer transition-transform duration-200 ${showVideoDropdown ? "rotate-180" : ""
                      }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (
                        meetingSettings?.roomType === "Webinar" &&
                        mode == Constants.modes.RECV_ONLY
                      ) {
                        return;
                      }
                      setShowVideoDropdown(!showVideoDropdown);
                      setShowMicDropdown(false);
                      setShowToolsDropdown(false);
                      setShowLayoutDropdown(false);
                      setShowMore(false);
                    }}
                    title="Video Settings"
                    draggable={false}
                  />
                </div>
              </div>
            </button>
            {/* Video Device Dropdown */}
            {showVideoDropdown && (
              <div
                data-video-dropdown
                className={`absolute top-full left-0 ${compactMode ? "-mt-4" : "mt-2"
                  } w-64 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 transition-all duration-300 ease-in-out`}
              >
                {/* Video Source Section */}
                <div className="px-4 py-2">
                  <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                    VIDEO SOURCE
                  </div>
                  <div className="relative">
                    <div
                      className="flex items-center justify-between w-full px-3 py-3 bg-[#1a1a2e] border border-white/30 rounded-lg text-white text-sm"
                      onClick={() => {
                        setShowVideoSourceDropdown(!showVideoSourceDropdown);
                      }}
                    >
                      <div className="flex items-center gap-3 min-w-0 flex-1">
                        <img
                          src="/icons/videoCamera.png"
                          alt="Camera"
                          className="w-5 h-5"
                        />
                        <span className="font-medium truncate min-w-0">
                          {selectedWebcam?.label || "Select camera"}
                        </span>
                      </div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        className="flex-shrink-0 ml-2"
                      >
                        <path
                          d="M3.5 5.5L8 10l4.5-4.5"
                          stroke="currentColor"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"
                        />
                      </svg>
                    </div>

                    {/* Camera List */}
                    {showVideoSourceDropdown && (
                      <div className="absolute top-full left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-[#060621] border border-gray-600 rounded-lg shadow-xl z-10">
                        {webcams.map((device) => (
                          <button
                            key={device.deviceId}
                            className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-3 min-w-0"
                            onClick={() => {
                              changeWebcam(device.deviceId);
                              setShowVideoDropdown(false);
                            }}
                          >
                            <img
                              src="/icons/videoCamera.svg"
                              alt="Camera"
                              className="flex-shrink-0"
                            />
                            <span className="truncate min-w-0">
                              {device.label ||
                                `Camera ${device.deviceId.slice(0, 8)}...`}
                            </span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Mirror Camera View Option */}
                <div className="px-4 py-2">
                  <div className="flex items-center gap-3">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    <span className="text-white text-sm">
                      Mirror Camera View
                    </span>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="px-4 py-2 space-y-2">
                  <button
                    onClick={() => {
                      setShowVirtualBackgroundModal(true);
                      setShowVideoDropdown(false);
                    }}
                    className="flex items-center gap-2 w-full px-4 py-3 bg-[#3A285F] text-white text-sm rounded-lg hover:bg-[#3A285F]/80 transition-colors"
                  >
                    <img
                      src="/icons/changeBg.png"
                      alt="Change Background"
                      className="w-4 h-4"
                    />
                    <span className="font-medium">CHANGE BACKGROUND</span>
                  </button>

                  <button
                    onClick={() => {
                      getWebcams();
                      setShowVideoDropdown(false);
                    }}
                    className="flex items-center gap-2 w-full px-4 py-3 bg-[#3A285F] text-white text-sm rounded-lg hover:bg-[#3A285F]/80 transition-colors"
                  >
                    <img
                      src="/icons/refresh.png"
                      alt="Refresh Devices"
                      className=""
                    />
                    <span className="font-medium">REFRESH DEVICES</span>
                  </button>
                </div>
              </div>
            )}
          </div>
          {!isMobile &&
            (["moderator", "co-host"].includes(meetingRole) ||
              (meetingSettings && meetingSettings.allowScreenSharing)) && (
              <div className="relative">
                <button
                  onClick={() => {
                    mMeeting.toggleScreenShare();
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title="Share"
                  aria-label="Share"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/shareScreen.svg"
                        alt="Share"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Share
                      </span>
                    )}
                  </div>
                </button>
              </div>
            )}
          {meetingSettings && meetingSettings.allowRaiseHand && (
            <div className="relative">
              <button
                onClick={() => {
                  publishRaiseHand("Raise Hand");
                  toast("Raised hand", {
                    position: "bottom-left",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Raise"
                aria-label="Raise"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    <img
                      src="/icons/raiseHand.svg"
                      alt="Raise"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Raise
                    </span>
                  )}
                </div>
              </button>
            </div>
          )}

          {(["moderator", "co-host"].includes(meetingRole) ||
            (!["moderator", "co-host"].includes(meetingRole) &&
              meetingSettings &&
              meetingSettings.allowReactions)) && (
              <div className="relative">
                <button
                  onClick={() => {
                    setShowReactions(!showReactions);
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title={"Reactions"}
                  aria-label={"Reactions"}
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/reaction.svg"
                        alt="Reactions"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Reactions
                      </span>
                    )}
                  </div>
                </button>
                {showReactions && (
                  <div
                    data-reactions-dropdown
                    className="absolute top-full right-0 md:right-auto md:left-0 mt-2 z-50 p-2 md:p-3 rounded-xl md:rounded-2xl shadow-2xl border border-gray-300 bg-white"
                    onMouseDown={(e) => e.stopPropagation()}
                  >
                    <div className="grid grid-cols-5 gap-1 md:gap-2 min-w-[180px] md:min-w-[220px]">
                      {emojis.map(({ char, alt }) => (
                        <button
                          key={char}
                          aria-label={alt}
                          title={alt}
                          onClick={() => handleEmojiClick({ char, alt })}
                          className="w-8 h-8 md:w-10 md:h-10 text-lg md:text-2xl rounded-lg md:rounded-xl transition-all duration-200 ease-out bg-white border border-gray-200 hover:bg-gray-50 hover:scale-110 hover:-translate-y-0.5 hover:shadow-lg hover:border-gray-300 active:scale-95 flex items-center justify-center"
                        >
                          {char}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            )}

          {["moderator", "co-host"].includes(meetingRole) && (
            <div className="relative">
              <button
                onClick={() => {
                  handleRecordingClick();
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title={"Record"}
                aria-label={"Record"}
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    <img
                      src={
                        mMeeting.recordingState ==
                          Constants.recordingEvents.RECORDING_STOPPED
                          ? "/icons/recordOff.svg"
                          : "/icons/recordOn.svg"
                      }
                      alt="Record"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Record
                    </span>
                  )}
                </div>
              </button>
            </div>
          )}
          {meetingRole === "moderator" &&
            meetingSettings &&
            meetingSettings.customButtonText &&
            meetingSettings.customButtonUrl && (
              <button
                onClick={() => {
                  window.open(meetingSettings.customButtonUrl, "_blank");
                }}
                className={`p-0 hover:text-white bg-[#7700ff] text-white rounded-md ${compactMode
                  ? "text-xs px-1 py-1 transition-all duration-300 ease-in-out"
                  : "text-sm mx-0.5 lg:mx-1 sm:text-sm px-1 py-1 sm:py-2 transition-all duration-300 ease-in-out"
                  }`}
                title={meetingSettings.customButtonText}
                aria-label={meetingSettings.customButtonText}
              >
                {meetingSettings.customButtonText}
              </button>
            )}
        </div>
      </div>

      {/* Center Section - Meeting Name */}
      <div className="flex-1 flex justify-center items-center w-1/7">
        <div className="bg-gray-800 px-1 sm:px-2 md:px-3 py-1 sm:py-2 rounded-lg flex items-center gap-1 sm:gap-2 max-w-full">
          {/* {showMeetingName && (
            <span className="text-[#7700FF] font-medium text-xs sm:text-sm md:text-base tracking-wide truncate">
              {meetingSettings?.roomName || "Meeting Name"}
            </span>
          )} */}
          {/* Chevron moved into bottom notch */}
          <span className="hidden" />
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center flex-shrink-0 w-3/7">
        {/* Mobile Right Section - Participant and Profile */}
        <div
          className={`${isMobileLike ? "flex" : "hidden"} items-center gap-3`}
        >
          {/* Mobile Participant Toggle */}
          <button
            onClick={() => {
              setSideBarMode((s) =>
                s === sideBarModes.PARTICIPANTS
                  ? null
                  : sideBarModes.PARTICIPANTS
              );
            }}
            className="relative flex items-center gap-1 text-white focus:outline-none"
            title="Participants"
            aria-label="Participants"
            type="button"
          >
            <span className="text-sm font-medium">
              {mMeeting && mMeeting.participants && mMeeting.participants.size}
            </span>
            <div className="relative">
              {participantApproveFunc?.length > 0 && (
                <span className="absolute -top-1 -right-1 z-10 inline-flex items-center justify-center min-w-[14px] h-3.5 px-1 rounded-full bg-red-500 text-white text-[9px] font-semibold">
                  {participantApproveFunc.length}
                </span>
              )}
              <img
                src="/icons/participants.svg"
                alt="Participants"
                className="w-5"
              />
            </div>
          </button>

          {/* Profile Icon */}
          <button
            onClick={() => {
              if (isAuthenticated) {
                window.open("/dashboard/profile", "_blank");
              }
            }}
            className={`p-0 text-slate-300 hover:text-white transition-colors duration-200 ${isMobileLike ? "mr-2" : ""
              }`}
            title="Profile"
            aria-label="Profile"
          >
            {user?.logo ? (
              <img
                alt="Profile"
                className="w-8 h-8 rounded-full object-cover border border-gray-600 hover:border-gray-400 transition-all duration-200"
                src={user?.logo}
              />
            ) : (
              <img
                alt="Profile"
                className="rounded-full hover:opacity-80 transition-opacity duration-200"
                src="/icons/profile.svg"
              />
            )}
          </button>
        </div>

        {!isMobileLike && (
          <div
            className={`hidden lg:flex items-center transition-all duration-300 ease-in-out ${compactMode
              ? "gap-1.5 xl:gap-2.5 2xl:gap-3"
              : "gap-0.5 xl:gap-2 2xl:gap-2.5"
              }`}
          >
            {["moderator", "co-host"].includes(meetingRole) && (
              <div className="relative">
                <button
                  onClick={() => {
                    setShowElementSection(!showElementSection);
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title="Elements"
                  aria-label="Elements"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/elements.svg"
                        alt="Elements"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Elements
                      </span>
                    )}
                  </div>
                </button>
              </div>
            )}
            {(["moderator", "co-host"].includes(meetingRole) ||
              (!["moderator", "co-host"].includes(meetingRole) &&
                meetingSettings.allowChat)) && (
                <div className="relative">
                  <button
                    onClick={() => {
                      setSideBarMode((s) =>
                        s === sideBarModes.CHAT ? null : sideBarModes.CHAT
                      );
                      setUnreadChat(false);
                    }}
                    className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                    title="Chat"
                    aria-label="Chat"
                  >
                    <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                      <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                        <img
                          src="/icons/chat.svg"
                          alt="Chat"
                          className="object-contain hover:opacity-80 transition-all duration-200"
                          draggable={false}
                        />
                      </div>
                      {!compactMode && (
                        <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                          Chat
                        </span>
                      )}
                      {unreadChat && (
                        <span className="absolute -top-0 right-1 text-blue-500 text-xs font-semibold flex items-center justify-center shadow-sm">
                          <span className="w-2 h-2 rounded-full bg-red-500"></span>
                        </span>
                      )}
                    </div>
                  </button>
                </div>
              )}
            <div className="relative">
              <button
                onClick={() => {
                  setSideBarMode((s) =>
                    s === sideBarModes.PARTICIPANTS
                      ? null
                      : sideBarModes.PARTICIPANTS
                  );
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Participants"
                aria-label="Participants"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="relative flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    {participantApproveFunc?.length > 0 && (
                      <span className="absolute -top-1 -right-1 z-10 inline-flex items-center justify-center min-w-[14px] h-3.5 px-1 rounded-full bg-red-500 text-white text-[9px] font-semibold">
                        {participantApproveFunc.length}
                      </span>
                    )}
                    <img
                      src="/icons/participants.svg"
                      alt="Participants"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                    {mMeeting &&
                      mMeeting.participants &&
                      mMeeting.participants.size && (
                        <span className="ml-1 text-white text-[10px] sm:text-xs font-medium">
                          {mMeeting.participants.size}
                        </span>
                      )}
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Participants
                    </span>
                  )}
                </div>
              </button>
            </div>
            <div className="relative">
              <button
                onClick={() => {
                  logger("log", "showToolsDropdown", showToolsDropdown);
                  setShowToolsDropdown(!showToolsDropdown);
                  setShowCaptionsDropdown(false);
                  setShowLayoutDropdown(false);
                  setShowVideoDropdown(false);
                  setShowAudioInputDropdown(false);
                  setShowMore(false);
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Tools"
                aria-label="Tools"
              >
                <div className="h-full flex items-center gap-1.5 transition-all duration-300 ease-in-out min-w-fit relative">
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/tools.svg"
                        alt="Tools"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Tools
                      </span>
                    )}
                  </div>
                  <div className="flex items-center justify-center opacity-100 transition-all duration-300 ease-in-out">
                    <img
                      src="/icons/chevronDown.svg"
                      alt="dropdown"
                      className={`cursor-pointer transition-transform duration-200 ${showToolsDropdown ? "rotate-180" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowToolsDropdown(!showToolsDropdown);
                        setShowCaptionsDropdown(false);
                        setShowLayoutDropdown(false);
                        setShowVideoDropdown(false);
                        setShowAudioInputDropdown(false);
                        setShowMore(false);
                      }}
                      title="Tools Settings"
                      draggable={false}
                    />
                  </div>
                </div>
              </button>

              {/* Tools Options */}
              {showToolsDropdown && (
                <div
                  data-tools-dropdown
                  className={`absolute grid grid-cols-2 top-full right-0 ${compactMode ? "-mt-4" : "mt-2"
                    } w-56 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 px-2 gap-2 transition-all duration-300 ease-in-out`}
                >
                  {/* Breakout Rooms Option */}
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      logger("log", "Breakout Rooms button clicked, setting modal to true");
                      logger("log", "Current showBreakoutRoomsModal state:", showBreakoutRoomsModal);
                      setShowBreakoutRoomsModal((prev) => {
                        logger("log", "Setting showBreakoutRoomsModal to true, previous value:", prev);
                        return true;
                      });
                      setShowToolsDropdown(false);
                      setShowLayoutDropdown(false);
                      setShowVideoDropdown(false);
                      setShowAudioInputDropdown(false);
                    }}
                    className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
                  >
                    <img
                      src="/icons/breakoutRoom.png"
                      alt="Breakout Rooms"
                      className="flex-shrink-0 w-6 h-6"
                    />
                    <span className="text-xs font-medium text-center whitespace-nowrap">
                      Breakout Rooms
                    </span>
                  </button>

                  {/* Whiteboard Option */}
                  {meetingRole === "moderator" && (
                    <button
                      onClick={() => {
                        startWhiteboard();
                        setShowToolsDropdown(false);
                        setShowLayoutDropdown(false);
                        setShowVideoDropdown(false);
                        setShowAudioInputDropdown(false);
                      }}
                      className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
                    >
                      <img
                        src="/icons/whiteboard.svg"
                        alt="Whiteboard"
                        className="flex-shrink-0 w-6 h-6"
                      />
                      <span className="text-xs font-medium text-center whitespace-nowrap">
                        Whiteboard
                      </span>
                    </button>
                  )}

                  {/* Live Stream Option */}
                  {["moderator", "co-host"].includes(meetingRole) && (
                    <button
                      onClick={() => {
                        if (isLiveStreaming) {
                          handleStopLiveStream();
                        } else {
                          setShowLiveStreamModal(true);
                        }
                        setShowToolsDropdown(false);
                        setShowLayoutDropdown(false);
                        setShowVideoDropdown(false);
                        setShowAudioInputDropdown(false);
                      }}
                      className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
                    >
                      <img
                        src={
                          isLiveStreaming
                            ? "/icons/liveOn.svg"
                            : "/icons/liveOff.svg"
                        }
                        alt="Live Stream"
                        className="flex-shrink-0 w-6 h-6"
                      />
                      <span className="text-xs font-medium text-center whitespace-nowrap">
                        Live Stream
                      </span>
                    </button>
                  )}

                  {/* Captions Option */}
                  <button
                    onClick={() => {
                      setShowCaptionsDropdown(!showCaptionsDropdown);
                    }}
                    className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
                  >
                    {!showCaptionsDropdown ? (
                      <img
                        src="/icons/captions.svg"
                        alt="Captions"
                        className="flex-shrink-0 w-6 h-6"
                      />
                    ) : (
                      <img
                        src="/icons/captionsSelected.svg"
                        alt="Captions"
                        className="flex-shrink-0 w-6 h-6"
                      />
                    )}
                    <span className="text-xs font-medium text-center whitespace-nowrap">
                      Captions
                    </span>
                  </button>
                </div>
              )}

              {/*  Captions Settings */}
              {showCaptionsDropdown && (
                <div
                  data-captions-dropdown
                  className="absolute top-full right-0 mt-2 w-60 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 p-4"
                >
                  {/* Live Stream Option */}
                  {["moderator", "co-host"].includes(meetingRole) && (
                    <button
                      onClick={() => {
                        if (isLiveStreaming) {
                          handleStopLiveStream();
                        } else {
                          setShowLiveStreamModal(true);
                        }
                        setShowToolsDropdown(false);
                        setShowLayoutDropdown(false);
                        setShowVideoDropdown(false);
                        setShowAudioInputDropdown(false);
                      }}
                      className="flex flex-col items-center gap-2 px-2 py-3 text-white transition-colors rounded-lg hover:bg-white/10"
                    >
                      <img
                        src={
                          isLiveStreaming
                            ? "/icons/liveOn.svg"
                            : "/icons/liveOff.svg"
                        }
                        alt="Live Stream"
                        className="flex-shrink-0 w-6 h-6"
                      />
                      <span className="text-xs font-medium text-center whitespace-nowrap">
                        Live Stream
                      </span>
                    </button>
                  )}

                  {/* Caption Toggle */}
                  <div className="px-4 py-3">
                    <div className="flex items-center justify-center">
                      <div className="flex bg-gray-700  p-1 rounded mt-2">
                        <button
                          onClick={() => {
                            if (translationEnabled) {
                              // stopTranslation();
                            }
                            setTranslationEnabled(false);
                          }}
                          className={`px-3 py-1  text-xs font-medium transition-colors ${!translationEnabled
                            ? "bg-[#7700ff] text-white"
                            : "text-gray-400 hover:text-white"
                            }`}
                        >
                          OFF
                        </button>
                        <button
                          onClick={() => {
                            // if (!translationEnabled) {
                            //   if (translationStatus === "stopped") {
                            //     startTranslation();
                            //   }
                            // }
                            if (mMeeting && mMeeting.translationState == Constants.translationEvents.TRANSLATION_STOPPED) {
                              startTranslation();
                            }
                            setTranslationEnabled(true);
                          }}
                          className={`px-3 py-1 text-xs font-medium transition-colors ${translationEnabled
                            ? "bg-[#7700FF] text-white"
                            : "text-gray-400 hover:text-white"
                            }`}
                        >
                          ON
                        </button>
                      </div>
                    </div>
                  </div>

                  {/* Loading State */}
                  {mMeeting && mMeeting.translationState === "starting" && (
                    <div className="px-3 py-6">
                      <div className="flex flex-col items-center justify-center gap-4">
                        {/* Animated Loader */}
                        <div className="relative w-16 h-16">
                          <div className="absolute inset-0 border-4 border-[#7700ff]/20 rounded-full"></div>
                          <div className="absolute inset-0 border-4 border-transparent border-t-[#7700ff] rounded-full animate-spin"></div>
                          <div
                            className="absolute inset-2 border-4 border-transparent border-r-[#7700ff] rounded-full animate-spin"
                            style={{
                              animationDirection: "reverse",
                              animationDuration: "0.8s",
                            }}
                          ></div>
                        </div>
                        {/* Loading Text */}
                        <div className="text-center">
                          <p className="text-white text-sm font-medium mb-1">
                            Please wait while loading the languages...
                          </p>
                          <p className="text-gray-400 text-xs">
                            This may take a few moments
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Translation Option */}
                  {translationEnabled && translationStatus === "started" && (
                    <div className="px-3 py-3">
                      <div className="text-white text-center text-sm tracking-widest font-medium mb-2">
                        TRANSLATE TO
                      </div>
                      <div className="relative">
                        <select
                          value={selectedLanguage}
                          onChange={(e) => {
                            changeTranslationLanguage(e.target.value);
                            setSelectedLanguage(e.target.value);
                          }}
                          className="w-full bg-[#060621] text-white text-sm px-3 py-4 pr-12 rounded-2xl border border-white focus:outline-none focus:border-[#7700ff] appearance-none"
                        >
                          {translationLanguages.map((language) => (
                            <option
                              key={language.code}
                              value={language.code}
                              selected={language.code === selectedLanguage}
                            >
                              {language.language}
                            </option>
                          ))}
                        </select>
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white pointer-events-none"
                        >
                          <path d="M7 10l5 5 5-5z" />
                        </svg>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="relative">
              <button
                onClick={() => {
                  setShowLayoutDropdown(!showLayoutDropdown);
                  setShowMicDropdown(false);
                  setShowVideoDropdown(false);
                  setShowSpeakerDropdown(false);
                  setShowCaptionsDropdown(false);
                  setShowToolsDropdown(false);
                  setShowMore(false);
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Layout"
                aria-label="Layout"
              >
                <div className="h-full flex items-center gap-1.5 transition-all duration-300 ease-in-out min-w-fit relative">
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/layout.svg"
                        alt="Layout"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Layout
                      </span>
                    )}
                  </div>
                  <div className="flex items-center justify-center opacity-100 transition-all duration-300 ease-in-out">
                    <img
                      src="/icons/chevronDown.svg"
                      alt="dropdown"
                      className={`cursor-pointer transition-transform duration-200 ${showLayoutDropdown ? "rotate-180" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowLayoutDropdown(!showLayoutDropdown);
                        setShowMicDropdown(false);
                        setShowVideoDropdown(false);
                        setShowSpeakerDropdown(false);
                        setShowCaptionsDropdown(false);
                        setShowToolsDropdown(false);
                        setShowMore(false);
                      }}
                      title="Layout Settings"
                      draggable={false}
                    />
                  </div>
                </div>
              </button>

              {/* Layout Dropdown */}
              {showLayoutDropdown && (
                <div
                  data-layout-dropdown
                  className={`absolute top-full right-0 ${compactMode ? "-mt-4" : "mt-2"
                    } w-80 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 px-4 transition-all duration-300 ease-in-out`}
                >
                  {/* VIEW Section */}
                  <div className="px-4 py-2">
                    <div className="text-white text-center text-sm tracking-widest font-medium mb-5">
                      VIEW
                    </div>

                    {/* Layout Options */}
                    <div className="grid grid-cols-2 gap-3">
                      {/* Gallery Layout */}
                      <button
                        onClick={() => {
                          setSelectedLayout("gallery");
                          setShowLayoutDropdown(false);
                        }}
                        className={`p-3 rounded-lg border transition-colors ${selectedLayout === "gallery"
                          ? "border-[#7700ff] bg-[#7700ff]/10"
                          : "border-gray-600 hover:border-gray-500"
                          }`}
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div className="">
                            <img
                              src="/icons/gallery.svg"
                              alt="gallery"
                              className="w-full h-full object-contain"
                            />
                          </div>
                          <span className="text-white text-xs">Gallery</span>
                        </div>
                      </button>

                      {/* Speaker Top Layout */}
                      <button
                        onClick={() => {
                          setSelectedLayout("speaker-top");
                          setShowLayoutDropdown(false);
                        }}
                        className={`p-3 rounded-lg border transition-colors ${selectedLayout === "speaker-top"
                          ? "border-[#7700ff] bg-[#7700ff]/10"
                          : "border-gray-600 hover:border-gray-500"
                          }`}
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div className="">
                            <img
                              src="/icons/speakerTop.svg"
                              alt="speakerTop"
                              className="w-full h-full object-contain"
                            />
                          </div>
                          <span className="text-white text-xs">
                            Speaker Top
                          </span>
                        </div>
                      </button>

                      {/* Focus Layout */}
                      <button
                        onClick={() => {
                          setSelectedLayout("focus");
                          setShowLayoutDropdown(false);
                        }}
                        className={`p-3 rounded-lg border transition-colors ${selectedLayout === "focus"
                          ? "border-[#7700ff] bg-[#7700ff]/10"
                          : "border-gray-600 hover:border-gray-500"
                          }`}
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div className="">
                            <img
                              src="/icons/speakerFocus.svg"
                              alt="focus"
                              className="w-full h-full object-contain"
                            />
                          </div>
                          <span className="text-white text-xs">Focus</span>
                        </div>
                      </button>

                      {/* Speaker Side Layout */}
                      <button
                        onClick={() => {
                          setSelectedLayout("speaker-side");
                          setShowLayoutDropdown(false);
                        }}
                        className={`p-3 rounded-lg border transition-colors ${selectedLayout === "speaker-side"
                          ? "border-[#7700ff] bg-[#7700ff]/10"
                          : "border-gray-600 hover:border-gray-500"
                          }`}
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div className="">
                            <img
                              src="/icons/speakerSide.svg"
                              alt="speakerSide"
                              className="w-full h-full object-contain"
                            />
                          </div>
                          <span className="text-white text-xs">
                            Speaker Side
                          </span>
                        </div>
                      </button>
                    </div>
                  </div>

                  {/* Separator */}
                  <div className="border-t border-gray-600 my-4"></div>

                  {/* OPTIONS Section */}
                  <div className="px-4 py-2">
                    <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                      OPTIONS
                    </div>

                    <div className="space-y-2">
                      {/* Fullscreen Option */}
                      <button
                        onClick={() => {
                          setIsFullscreen(!isFullscreen);
                          setShowLayoutDropdown(false);
                          handleToggleFullscreen();
                        }}
                        className={`w-full text-left px-3 py-2 text-sm ${!isFullscreen
                          ? "text-gray-400 hover:text-white"
                          : "text-white hover:bg-white/10 transition-colors"
                          }`}
                      >
                        Fullscreen
                      </button>

                      {/* Hide self view Option */}
                      {mMeeting &&
                        mMeeting.participants &&
                        Array.from(mMeeting.participants.keys()).length > 1 && (
                          <button
                            onClick={() => {
                              setHideSelfView(!hideSelfView);
                              setShowLayoutDropdown(false);
                            }}
                            className={`w-full text-left px-3 py-2 text-sm ${hideSelfView ? "text-white" : "text-gray-400"
                              }`}
                          >
                            Hide self view
                          </button>
                        )}

                      {/* Show non-video participants Option */}
                      {selectedLayout == "gallery" && (
                        <button
                          onClick={() => {
                            setShowNonVideoParticipants(
                              !showNonVideoParticipants
                            );
                            setShowLayoutDropdown(false);
                          }}
                          className={`w-full text-left px-3 py-2 text-sm ${showNonVideoParticipants
                            ? "text-white"
                            : "text-gray-400"
                            }`}
                        >
                          Show non-video participants
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="relative">
              <button
                onClick={() => {
                  setShowMore(!showMore);
                  setShowLayoutDropdown(false);
                  setShowMicDropdown(false);
                  setShowVideoDropdown(false);
                  setShowSpeakerDropdown(false);
                  setShowCaptionsDropdown(false);
                  setShowToolsDropdown(false);
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Settings"
                aria-label="Settings"
              >
                <div className="h-full flex items-center gap-1.5 transition-all duration-300 ease-in-out min-w-fit relative">
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/settings.svg"
                        alt="Settings"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Settings
                      </span>
                    )}
                  </div>
                  <div className="flex items-center justify-center opacity-100 transition-all duration-300 ease-in-out">
                    <img
                      src="/icons/chevronDown.svg"
                      alt="dropdown"
                      className={`cursor-pointer transition-transform duration-200 ${showMore ? "rotate-180" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowMore(!showMore);
                        setShowMicDropdown(false);
                        setShowVideoDropdown(false);
                        setShowSpeakerDropdown(false);
                        setShowCaptionsDropdown(false);
                        setShowToolsDropdown(false);
                      }}
                      title="Settings"
                      draggable={false}
                    />
                  </div>
                </div>
              </button>

              {/* {showMore && (
                <div
                  data-more-dropdown
                  className={`absolute top-full right-0 ${
                    compactMode ? "-mt-4" : "mt-2"
                  } w-80 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 px-4 transition-all duration-300 ease-in-out`}
                >
                  <button
                    className="w-full text-left px-3 py-2 text-white hover:bg-white/10"
                    onClick={handleToggleFullscreen}
                  >
                    Toggle Full Screen
                  </button>
                  <button
                    className="w-full text-left px-3 py-2 text-white hover:bg-white/10"
                    onClick={handleCopyRoomLink}
                  >
                    Copy Room Link
                  </button>
                </div>
              )} */}
            </div>

            <div className="relative">
              <button
                onClick={handleLeaveModal}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Logout"
                aria-label="Logout"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    <img
                      src="/icons/logout.svg"
                      alt="Logout"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <>
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Logout
                      </span>
                    </>
                  )}
                </div>
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Mobile Bottom Bar */}
      <MobileBottomBar
        isMobileLike={isMobileLike}
        isMobileLandscape={isMobileLike && isLandscapeOrientation}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        setShowMobilePanel={setShowMobilePanel}
        localMicOn={localMicOn}
        handleToggleMic={handleToggleMic}
        showMicDropdown={showMicDropdown}
        mics={mics}
        selectedMic={selectedMic}
        changeMic={changeMic}
        showAudioInputDropdown={showAudioInputDropdown}
        setShowAudioInputDropdown={setShowAudioInputDropdown}
        speakers={speakers}
        selectedSpeaker={selectedSpeaker}
        setSelectedSpeaker={setSelectedSpeaker}
        showSpeakerDropdown={showSpeakerDropdown}
        setShowSpeakerDropdown={setShowSpeakerDropdown}
        getMics={getMics}
        setShowMicDropdown={setShowMicDropdown}
        localWebcamOn={localWebcamOn}
        mMeeting={mMeeting}
        showVideoDropdown={showVideoDropdown}
        webcams={webcams}
        selectedWebcam={selectedWebcam}
        changeWebcam={changeWebcam}
        showVideoSourceDropdown={showVideoSourceDropdown}
        setShowVideoSourceDropdown={setShowVideoSourceDropdown}
        setShowVirtualBackgroundModal={setShowVirtualBackgroundModal}
        getWebcams={getWebcams}
        setShowVideoDropdown={setShowVideoDropdown}
        setSideBarMode={setSideBarMode}
        unreadChat={unreadChat}
        setUnreadChat={setUnreadChat}
        setShowHelpModal={() => { }}
        handleLeaveModal={handleLeaveModal}
      />

      {/* Mobile Swipe-Up Panel */}
      <MobileSwipeUpPanel
        showMobilePanel={showMobilePanel}
        isMobileLike={isMobileLike}
        isMobileLandscape={isMobileLike && isLandscapeOrientation}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        setShowMobilePanel={setShowMobilePanel}
        setShowCaptionsDropdown={setShowCaptionsDropdown}
        showCaptionsDropdown={showCaptionsDropdown}
        setShowReactions={setShowReactions}
        showReactions={showReactions}
        setShowToolsDropdown={setShowToolsDropdown}
        setShowLayoutDropdown={setShowLayoutDropdown}
        showLayoutDropdown={showLayoutDropdown}
        meetingRole={meetingRole}
        mMeeting={mMeeting}
        handleRecordingClick={handleRecordingClick}
        meetingSettings={meetingSettings}
        publishRaiseHand={publishRaiseHand}
        showMore={showMore}
        setShowMore={setShowMore}
        setShowHelpModal={() => { }}
        translationEnabled={translationEnabled}
        setTranslationEnabled={setTranslationEnabled}
        stopTranslation={stopTranslation}
        startTranslation={startTranslation}
        selectedLanguage={selectedLanguage}
        changeTranslationLanguage={changeTranslationLanguage}
        setSelectedLanguage={setSelectedLanguage}
        translationStatus={translationStatus}
        showElementSection={showElementSection}
        setShowElementSection={setShowElementSection}
        setShowPollsModal={() => { }}
        handleEmojiClick={handleEmojiClick}
        setShowCaptionTranslationPanel={setShowCaptionTranslationPanel}
        // Layout controls
        selectedLayout={selectedLayout}
        setSelectedLayout={setSelectedLayout}
        hideSelfView={hideSelfView}
        setHideSelfView={setHideSelfView}
        showNonVideoParticipants={showNonVideoParticipants}
        setShowNonVideoParticipants={setShowNonVideoParticipants}
        handleToggleFullscreen={handleToggleFullscreen}
        isFullscreen={isFullscreen}
      />

      <SettingsPanel
        show={showMore}
        compactMode={compactMode}
        isMobileLike={isMobileLike}
        setShowHelpModal={() => { }}
        setShowMore={setShowMore}
        handleToggleFullscreen={handleToggleFullscreen}
        handleCopyRoomLink={handleCopyRoomLink}
        user={user}
        TranscriptionToggleRow={TranscriptionToggleRow}
        WaitingRoomToggleRow={WaitingRoomToggleRow}
        GuestCanUnmuteToggleRow={GuestCanUnmuteToggleRow}
        ApprovalSoundToggleRow={ApprovalSoundToggleRow}
        meetingRole={meetingRole}
        webinarMode={true}
      />

      {/* Caption Translation Panel - Similar to Settings Panel */}
      <CaptionTranslationPanel
        show={showCaptionTranslationPanel}
        isMobileLike={isMobileLike}
        setShowCaptionTranslationPanel={setShowCaptionTranslationPanel}
        translationEnabled={translationEnabled}
        setTranslationEnabled={setTranslationEnabled}
        stopTranslation={stopTranslation}
        startTranslation={startTranslation}
        selectedLanguage={selectedLanguage}
        changeTranslationLanguage={changeTranslationLanguage}
        setSelectedLanguage={setSelectedLanguage}
        translationStatus={translationStatus}
        mMeeting={mMeeting}
      />

      {/* Virtual Background Modal */}
      {showVirtualBackgroundModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setShowVirtualBackgroundModal(false)}
          ></div>

          {/* Modal Content */}
          <div className="fixed left-0 top-[80px] bg-[#060621] rounded-lg shadow-xl w-full max-w-md mx-4 border border-gray-600">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-600">
              <h3 className="text-lg font-semibold text-white">
                Choose Virtual Background
              </h3>
              <button
                onClick={() => setShowVirtualBackgroundModal(false)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Blur Controls */}
            <div className="p-4 border-b border-gray-600">
              <div className="space-y-4">
                {/* Blur Toggle */}
                <div className="flex items-center justify-between">
                  <span className="text-white text-sm font-medium">
                    BLUR YOUR BACKGROUND
                  </span>
                  <div className="flex bg-gray-700 p-1 rounded">
                    <button
                      onClick={() => setBlurEnabled(false)}
                      className={`px-3 py-1 text-xs font-medium transition-colors ${!blurEnabled
                        ? "bg-[#7700ff] text-white"
                        : "text-gray-400 hover:text-white"
                        }`}
                    >
                      OFF
                    </button>
                    <button
                      onClick={() => setBlurEnabled(true)}
                      className={`px-3 py-1 text-xs font-medium transition-colors ${blurEnabled
                        ? "bg-[#7700ff] text-white"
                        : "text-gray-400 hover:text-white"
                        }`}
                    >
                      ON
                    </button>
                  </div>
                </div>

                {/* Blur Strength Slider */}
                {blurEnabled && (
                  <div className="space-y-2">
                    <span className="text-white text-sm font-medium">
                      Blur Strength
                    </span>
                    <div className="relative">
                      <input
                        type="range"
                        min="0"
                        max="100"
                        value={blurStrength}
                        onChange={(e) =>
                          setBlurStrength(parseInt(e.target.value))
                        }
                        className="w-full h-2 bg-gray-700 rounded-lg appearance-none cursor-pointer slider"
                        style={{
                          background: `linear-gradient(to right, #7700ff 0%, #7700ff ${blurStrength}%, #374151 ${blurStrength}%, #374151 100%)`,
                        }}
                      />
                      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-xs font-medium">
                        {blurStrength}%
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Background Options */}
            <div className="p-4 h-[60vh] overflow-y-auto">
              <div className="space-y-3">
                <span className="text-white text-sm font-medium">
                  BLUR YOUR BACKGROUND
                </span>
                <div className="grid grid-cols-2 gap-3">
                  {/* No Background Option */}
                  <button
                    onClick={() => {
                      handleStartVirtualBackground(null);
                      setShowVirtualBackgroundModal(false);
                    }}
                    className={`p-4 rounded-lg border transition-colors ${!virtualBackgroundOn
                      ? "border-[#7700ff] bg-[#7700ff]/10"
                      : "border-gray-600 hover:border-gray-500"
                      }`}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center">
                        <svg
                          className="w-6 h-6 text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </div>
                      <span className="text-white text-xs text-center">
                        No Background
                      </span>
                    </div>
                  </button>

                  {/* Upload Image Option */}
                  <button className="p-4 rounded-lg border-2 border-dashed border-[#7700ff] hover:border-[#7700ff]/80 transition-colors">
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center">
                        <svg
                          className="w-6 h-6 text-[#7700ff]"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                        </svg>
                      </div>
                      <span className="text-white text-xs text-center">
                        UPLOAD YOUR IMAGE
                      </span>
                    </div>
                  </button>
                </div>

                {/* Background Images Grid */}
                <div className="grid grid-cols-2 gap-3 mt-4">
                  {backgroundImageUrls.map((background, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        handleStartVirtualBackground(background);
                        setShowVirtualBackgroundModal(false);
                      }}
                      className={`rounded-lg overflow-hidden transition-colors ${virtualBackgroundOn && selectedBackground === background
                        ? "ring-2 ring-[#7700ff]"
                        : "hover:ring-2 hover:ring-gray-500"
                        }`}
                    >
                      <img
                        className="w-full h-20 object-cover"
                        src={background}
                        alt={`Background ${index + 1}`}
                      />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLeaveModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* dim background */}
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setShowLeaveModal(false)}
          />
          {/* center content */}
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-lg mx-4 text-white shadow-2xl">
            {/* Close Button */}
            <div className="flex items-center justify-end mb-4">
              <button
                onClick={() => setShowLeaveModal(false)}
                className="text-gray-400 hover:text-white transition-colors p-2 hover:bg-gray-700/50 rounded-full"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Title */}
            <h3 className="text-xl font-bold text-center mb-2">Leave Room?</h3>

            {/* Description */}
            <p className="text-gray-300 text-center mb-6 text-sm">
              You're about to leave this room. Choose how you'd like to proceed:
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col gap-3">
              {/* Stay */}
              <button
                className="w-full px-6 py-3 rounded-lg bg-gray-600 hover:bg-gray-700 text-white font-medium transition-colors"
                onClick={() => setShowLeaveModal(false)}
              >
                Stay in Room
              </button>

              {/* Leave */}
              <button
                className="w-full px-6 py-3 rounded-lg bg-red-600 hover:bg-red-700 text-white font-medium transition-colors"
                onClick={handleLeaveConfirm}
              >
                Leave Room
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes floatUp{0%{transform:translateY(0) translateX(0) scale(1);opacity:1}25%{transform:translateY(-25vh) translateX(20px) scale(1.1);opacity:.85}50%{transform:translateY(-50vh) translateX(0) scale(1.15);opacity:.7}75%{transform:translateY(-75vh) translateX(-20px) scale(1.1);opacity:.5}100%{transform:translateY(-100vh) translateX(0) scale(1);opacity:0}}`}</style>
      <div
        className="pointer-events-none fixed"
        style={{ bottom: 72, left: "7%", zIndex: 1302 }}
      >
        {recentReactions.slice(-6).map((r) => (
          <div
            key={r.id}
            className="mt-1 flex flex-col items-center"
            style={{
              animation: "floatUp 6s ease-out forwards",
              filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.2))",
            }}
          >
            <div className="text-[28px] mb-0.5">{r.emoji}</div>
            <div className="mt-0.5 px-1.5 py-0.5 rounded bg-black/60 text-white text-[10px]">
              {/* {getParticipantName(r.from)} */}
              {r.from}
            </div>
          </div>
        ))}
      </div>
      {/* Live Streaming Modal */}
      {showLiveStreamModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowLiveStreamModal(false)}
          />
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-2xl mx-4 text-white max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-end mb-2">
              <button
                onClick={() => setShowLiveStreamModal(false)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <h3 className="text-xl font-bold uppercase text-center">
              Live Streaming
            </h3>

            {/* Platform Selection */}
            <div className="space-y-4 mb-6">
              {/* YouTube */}
              <div className="space-y-3 border-b border-gray-700 pb-3">
                <div className="flex items-center justify-between p-4 ">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center">
                      <img
                        src="/icons/yt.svg"
                        alt="YouTube"
                        className="w-8 h-8"
                      />
                    </div>
                    <div>
                      <div className="font-medium">YouTube</div>
                    </div>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={liveStreamPlatforms.youtube}
                      onChange={(e) =>
                        setLiveStreamPlatforms((prev) => ({
                          ...prev,
                          youtube: e.target.checked,
                        }))
                      }
                    />
                    <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-red-600"></div>
                  </label>
                </div>
                {liveStreamPlatforms.youtube && (
                  <div className="pl-12 space-y-2">
                    <input
                      type="text"
                      placeholder="Stream URL"
                      value={streamingCredentials.youtube.url}
                      onChange={(e) =>
                        setStreamingCredentials((prev) => ({
                          ...prev,
                          youtube: { ...prev.youtube, url: e.target.value },
                        }))
                      }
                      className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-red-600"
                    />
                    <input
                      type="text"
                      placeholder="Stream Key"
                      value={streamingCredentials.youtube.key}
                      onChange={(e) =>
                        setStreamingCredentials((prev) => ({
                          ...prev,
                          youtube: { ...prev.youtube, key: e.target.value },
                        }))
                      }
                      className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-red-600"
                    />
                  </div>
                )}
              </div>

              {/* Facebook */}
              <div className="space-y-3 border-b border-gray-700 pb-3">
                <div className="flex items-center justify-between p-4 ">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center">
                      <img
                        src="/icons/fb.svg"
                        alt="Facebook"
                        className="w-8 h-8"
                      />
                    </div>
                    <div>
                      <div className="font-medium">Facebook</div>
                    </div>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={liveStreamPlatforms.facebook}
                      onChange={(e) =>
                        setLiveStreamPlatforms((prev) => ({
                          ...prev,
                          facebook: e.target.checked,
                        }))
                      }
                    />
                    <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                  </label>
                </div>
                {liveStreamPlatforms.facebook && (
                  <div className="pl-12 space-y-2">
                    <input
                      type="text"
                      placeholder="Stream URL"
                      value={streamingCredentials.facebook.url}
                      onChange={(e) =>
                        setStreamingCredentials((prev) => ({
                          ...prev,
                          facebook: { ...prev.facebook, url: e.target.value },
                        }))
                      }
                      className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-600"
                    />
                    <input
                      type="text"
                      placeholder="Stream Key"
                      value={streamingCredentials.facebook.key}
                      onChange={(e) =>
                        setStreamingCredentials((prev) => ({
                          ...prev,
                          facebook: { ...prev.facebook, key: e.target.value },
                        }))
                      }
                      className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-600"
                    />
                  </div>
                )}
              </div>

              {/* LinkedIn */}
              <div className="space-y-3 ">
                <div className="flex items-center justify-between p-4 ">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center">
                      <img
                        src="/icons/linkedin.svg"
                        alt="LinkedIn"
                        className="w-8 h-8"
                      />
                    </div>
                    <div>
                      <div className="font-medium">LinkedIn</div>
                    </div>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={liveStreamPlatforms.linkedin}
                      onChange={(e) =>
                        setLiveStreamPlatforms((prev) => ({
                          ...prev,
                          linkedin: e.target.checked,
                        }))
                      }
                    />
                    <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-700"></div>
                  </label>
                </div>
                {liveStreamPlatforms.linkedin && (
                  <div className="pl-12 space-y-2">
                    <input
                      type="text"
                      placeholder="Stream URL"
                      value={streamingCredentials.linkedin.url}
                      onChange={(e) =>
                        setStreamingCredentials((prev) => ({
                          ...prev,
                          linkedin: { ...prev.linkedin, url: e.target.value },
                        }))
                      }
                      className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-700"
                    />
                    <input
                      type="text"
                      placeholder="Stream Key"
                      value={streamingCredentials.linkedin.key}
                      onChange={(e) =>
                        setStreamingCredentials((prev) => ({
                          ...prev,
                          linkedin: { ...prev.linkedin, key: e.target.value },
                        }))
                      }
                      className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-700"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex gap-3 justify-end">
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-transparent border border-white text-white hover:bg-white/10"
                onClick={() => setShowLiveStreamModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-transparent border border-[#00C853] text-[#00C853] hover:bg-white/10"
                onClick={() => handleStartLiveStream(liveStreamPlatforms)}
              >
                Go Live
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Breakout Rooms Modal - Render using Portal to ensure it's above all other elements */}
      {typeof document !== 'undefined' && createPortal(
        ["moderator", "co-host"].includes(meetingRole) ? (
          <BreakoutRoomsModal
            isOpen={showBreakoutRoomsModal}
            onClose={() => {
              logger("log", "Closing breakout rooms modal");
              setShowBreakoutRoomsModal(false);
            }}
            meetingRole={meetingRole}
          />
        ) : (
          <BreakoutRoomsParticipantPanel
            isOpen={showBreakoutRoomsModal}
            onClose={() => {
              logger("log", "Closing breakout rooms participant panel");
              setShowBreakoutRoomsModal(false);
            }}
          />
        ),
        document.body
      )}
    </div>
  );
};

export default TopBarWebinar;
